<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        การจัดการ กลุ่มพนักงาน
      </span>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee_group:create')"
        color="primary"
        @click="handleAddEmployeesGroupForm"
      >
        <v-icon small left>mdi-plus</v-icon>เพิ่มกลุ่มพนักงาน
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="employeesGroup"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <EmployeeGroupForm
      :formShow="employeeGroupFormShow"
      :formAction="employeeGroupFormAction"
      :employeeGroup="employeeGroup"
      :employeeGroupInit="employeeGroupInit"
      @isEmployeeGroupDataChange="handleEmployeeGroupFormDataChange"
      @formActionCompleted="handleEmployeeGroupFormActionCompleted"
      @onReset="handleEmployeeGroupFormReset"
      @onClickAddEmployee="employeeGroupAddShow = true"
      @addEmployeeGroupSuccess="handleAddEmployeeGroupSuccess"
    />
    <EmployeeGroupAdd
      :formShow="employeeGroupAddShow"
      :employeeGroup="employeeGroup"
      :employeeGroupInit="employeeGroupInit"
      @isEmployeeGroupAddDataChange="handleEmployeeGroupAddDataChange"
      @onClickBlack="employeeGroupAddShow = false"
      @addEmployeeGroupMemberSuccess="handleAddEmployeeGroupMemberSuccess"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        (employeeGroupFormShow && employeeGroupFormAction === 'add') ||
        employeeGroupAddShow
      "
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeGroupAdd from '@/views/employees-group/EmployeeGroupAdd.vue'
import EmployeeGroupForm from '@/views/employees-group/EmployeeGroupForm.vue'

export default {
  components: {
    EmployeeGroupForm,
    EmployeeGroupAdd,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['employee_group_code'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      employeeGroupFormShow: false,
      employeeGroupAddShow: false,
      employeeGroupFormAction: '',
      employeeGroup: {},
      employeeGroupInit: {},
      isEmployeeGroupDataChange: false,
      isEmployeeGroupAddDataChange: false,
      timeout: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    headers() {
      return [
        {
          text: 'รหัสกลุ่มพนักงาน',
          align: 'start',
          value: 'employee_group_code',
        },
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        {
          text: 'จำนวนพนักงาน',
          align: 'start',
          value: 'total_employee',
        },
      ]
    },
    employeesGroup() {
      return this.$store.state.employeesGroup.employeesGroup
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ กลุ่มพนักงาน',
        disabled: true,
      },
    ])

    this.loading = true

    const { company_uuid } = this.$store.state.authentication.company

    Promise.all([
      this.fetchEmployeesGroup({ company_uuid }),
      this.fetchOrganizations({
        company_uuid,
        params: {
          dpc: 'access-employee-group-to-list-organization',
          field: 'organization_uuid,organization_code,title_th',
        },
      }),
    ])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchOrganizations: 'organization/fetchOrganizations',
      fetchEmployeesGroup: 'employeesGroup/fetchEmployeesGroup',
    }),
    handleAddEmployeeGroupMemberSuccess(employeeGroup) {
      this.employeeGroupAddShow = false
      this.employeeGroup = { ...employeeGroup }
      this.employeeGroupInit = { ...employeeGroup }
    },
    handleAddEmployeeGroupSuccess(employeeGroup) {
      this.employeeGroup = { ...employeeGroup }
      this.employeeGroupInit = { ...employeeGroup }
    },
    classRowSelected(row) {
      if (this.employeeGroup.employee_group_uuid === row.employee_group_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::employee_group:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.employeeGroup.employee_group_uuid === row.employee_group_uuid) {
        this.employeeGroupFormShow = false
        this.employeeGroupFormAction = ''
        this.employeeGroup = {}
        this.employeeGroupInit = {}
      } else {
        this.employeeGroupFormShow = true
        this.employeeGroupFormAction = 'edit'
        this.employeeGroup = { ...row }
        this.employeeGroupInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isEmployeeGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddEmployeesGroupForm() {
      this.employeeGroupFormShow = true
      this.employeeGroupFormAction = 'add'
      this.employeeGroup = {}
      this.employeeGroupInit = {}
    },
    handleEmployeeGroupFormDataChange(value) {
      this.isEmployeeGroupDataChange = value
    },
    handleEmployeeGroupAddDataChange(value) {
      this.isEmployeeGroupAddDataChange = value
    },
    handleEmployeeGroupFormReset(formAction) {
      if (formAction === 'edit') {
        this.employeeGroup = { ...this.employeeGroupInit }
      }
    },
    handleEmployeeGroupFormActionCompleted(formAction) {
      this.employeeGroup = {}
      this.employeeGroupInit = {}
      this.employeeGroupFormShow = false
      this.employeeGroupFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.employeeGroupFormShow = false
      this.employeeGroupAddShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEmployeeGroupDataChange || this.isEmployeeGroupAddDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
